<template>
  <span 
    :class="[
      'inline-flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium',
      riskLevelColor
    ]"
  >
    <span v-if="showIcon">{{ riskLevelIcon }}</span>
    <span class="capitalize">{{ level }}</span>
    <span v-if="score !== undefined" class="text-xs opacity-75">({{ score }})</span>
  </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  level: {
    type: String,
    required: true,
    validator: (value) => ['critical', 'high', 'medium', 'low', 'minimal', 'unknown'].includes(value)
  },
  score: {
    type: Number,
    default: undefined
  },
  showIcon: {
    type: Boolean,
    default: true
  }
})

const riskLevelColor = computed(() => {
  const colors = {
    critical: 'bg-red-100 text-red-800 border-red-200 dark:bg-red-900/30 dark:text-red-400 dark:border-red-800',
    high: 'bg-orange-100 text-orange-800 border-orange-200 dark:bg-orange-900/30 dark:text-orange-400 dark:border-orange-800',
    medium: 'bg-yellow-100 text-yellow-800 border-yellow-200 dark:bg-yellow-900/30 dark:text-yellow-400 dark:border-yellow-800',
    low: 'bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-900/30 dark:text-blue-400 dark:border-blue-800',
    minimal: 'bg-green-100 text-green-800 border-green-200 dark:bg-green-900/30 dark:text-green-400 dark:border-green-800',
    unknown: 'bg-gray-100 text-gray-800 border-gray-200 dark:bg-gray-900/30 dark:text-gray-400 dark:border-gray-800'
  }
  return colors[props.level] || colors.unknown
})

const riskLevelIcon = computed(() => {
  const icons = {
    critical: '🚨',
    high: '⚠️',
    medium: '⚡',
    low: '📋',
    minimal: '✅',
    unknown: '❓'
  }
  return icons[props.level] || icons.unknown
})
</script>